import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageService } from 'src/shared/services/storage/storage.service';
import { APIHelper } from 'src/shared/services/api-helper/api-helper.service';
import { API_URLS } from 'src/environments/env-routes';

@Injectable({
  providedIn: 'root'
})
export class SignatureService {

  constructor(private storage: StorageService,private api: APIHelper) { }

  public getFileContent(id: string) {

    const token = this.storage.getAsync({key: 'token'});

const args='attachment=true&alf_ticket=' + token;
    return this.api.requestApi({
      action: API_URLS.signature.getContent.replace(':nodeId',id),
      queryArgs:args,
      httpParams: {responseType: 'blob'}
    });
}
  // Get signature options from alfresco-global.properties (Custom REST API)
  public getSignatureOptions() {

    const token = this.storage.getAsync({key: 'token'});

    const args='alf_ticket=' + token;
    
    return this.api.requestApi({
      action: API_URLS.signature.getParams,
      queryArgs:args
    });
  
}

//Save signature and signer data in Alfresco Repository (Custom REST API)
    public saveSignature(id: string,
        certificateBase64: string,
        mimeType: string,
        signerPosition: string,
        signatureBase64: string) {

          const token = this.storage.getAsync({key: 'token'});
          const args='alf_ticket=' + token;
          const datas={
                       nodeRef: 'workspace://SpacesStore/' + id,
                       signedData: signatureBase64,
                       signerData: certificateBase64,
                       mimeType: mimeType,
                       signerPostition: signerPosition
                      }

  return this.api.requestApi({
    action:API_URLS.signature.saveSignature,
    method: 'POST',
    datas: datas,
    queryArgs:args
  });
    }
}
